// @flow strict

/**
 * Actions
 *
 * Define constant types for each action
 * For each type, define action to pass data/errors as payload
 */

import type { Client, ClientQueryType } from './types';

export const CREATE_SUCCESS = 'app/services/Client/CREATE_SUCCESS';
export const CREATE_FAILURE = 'app/services/Client/CREATE_FAILURE';
export const FETCH_LIST_SUCCESS = 'app/services/Client/FETCH_LIST_SUCCESS';
export const FETCH_LIST_FAILURE = 'app/services/Client/FETCH_LIST_FAILURE';
export const UPDATE_SUCCESS = 'app/services/Client/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'app/services/Client/UPDATE_FAILURE';
export const DESTROY_SUCCESS = 'app/services/Client/DESTROY_SUCCESS';
export const DESTROY_FAILURE = 'app/services/Client/DESTROY_FAILURE';
export const QUERY_LIST_SUCCESS = 'app/services/Clients/QUERY_LIST_SUCCESS';
export const QUERY_LIST_FAILURE = 'app/services/Clients/QUERY_LIST_FAILURE';
export const IS_FETCHING = 'app/services/Client/IS_FETCHING';
export const IS_UPDATING = 'app/services/Client/IS_UPDATING';
export const IS_DELETING = 'app/services/Client/IS_DELETING';
export const IS_CREATING = 'app/services/Client/IS_CREATING';
export const IS_QUERYING = 'app/services/Client/IS_QUERYING';

export const receivedCreateSuccess = (data: Client) => ({
    type: CREATE_SUCCESS,
    payload: { data },
});

export const receivedCreateFailure = (errors: {}) => ({
    type: CREATE_FAILURE,
    payload: { errors },
});

export const receivedFetchListSuccess = (data: Array<Client>) => ({
    type: FETCH_LIST_SUCCESS,
    payload: { data },
});

export const receivedFetchListFailure = (errors: {}) => ({
    type: FETCH_LIST_FAILURE,
    payload: { errors },
});

export const receivedUpdateSuccess = (data: Client) => ({
    type: UPDATE_SUCCESS,
    payload: { data },
});

export const receivedUpdateFailure = (errors: {}) => ({
    type: UPDATE_FAILURE,
    payload: { errors },
});

export const receivedDestroySuccess = (data: Client) => ({
    type: DESTROY_SUCCESS,
    payload: { data },
});

export const receivedDestroyFailure = (errors: {}) => ({
    type: DESTROY_FAILURE,
    payload: { errors },
});

export const receivedQueryListSuccess = (data: ClientQueryType) => ({
    type: QUERY_LIST_SUCCESS,
    payload: { data },
});

export const receivedQueryListFailure = (errors: {}) => ({
    type: QUERY_LIST_FAILURE,
    payload: { errors },
});

export const setIsFetchingStatus = (isFetching: boolean = true) => ({
    type: IS_FETCHING,
    payload: { isFetching },
});

export const setIsUpdatingStatus = (isUpdating: boolean = true) => ({
    type: IS_UPDATING,
    payload: { isUpdating },
});

export const setIsDeletingStatus = (isDeleting: boolean = true) => ({
    type: IS_DELETING,
    payload: { isDeleting },
});

export const setIsCreatingStatus = (isCreating: boolean = true) => ({
    type: IS_CREATING,
    payload: { isCreating },
});

export const setIsQueryStatus = (isQuerying: boolean = true) => ({
    type: IS_QUERYING,
    payload: { isQuerying },
});
